up.compiler('#js-expand_collapse_payout_history', function (button) {
  button.addEventListener('click', function () {
    const payoutTable = document.querySelector('.js-payout_history_table')

    if (payoutTable.classList.contains('collapsed')) {
      payoutTable.classList.remove('collapsed')
      button.setAttribute('aria-expanded', 'true')
      button.textContent = button.dataset.textExpanded
    } else {
      payoutTable.classList.add('collapsed')
      button.setAttribute('aria-expanded', 'false')
      button.textContent = button.dataset.textCollapsed
    }
  })
})
